/**
 * The API's base address as this site calls it, from NUXT_PUBLIC_API_BASE: trimmed, without a
 * trailing slash, and ending in /api whether or not the setting did. Empty means the site's own
 * origin (`/api`, the dev proxy). The one copy: the page's config, its fetch plugin, and
 * `/dockautomation.json` (the Tablet Browser app reads it to find the API) all use it.
 */
export function apiBaseFrom(raw: unknown): string {
  const input = String(raw ?? '').trim().replace(/\/+$/, '')
  if (!input) return '/api'
  // Preserve explicit api-path configuration.
  if (/\/api$/i.test(input)) return input
  // A host or root given without /api gets it, to match the backend's routes.
  if (/^https?:\/\//i.test(input) || input.startsWith('/')) return `${input}/api`
  return input
}
